import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import '../styles/PaymentForm.css';

function PaymentForm({ clientSecret, onSuccess, onError, amount }) {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setProcessing(true);
    setErrorMessage('');

    try {
      const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      });

      if (error) {
        setErrorMessage(error.message);
        setProcessing(false);
        if (onError) {
          onError(error);
        }
      } else if (paymentIntent.status === 'succeeded') {
        setProcessing(false);
        if (onSuccess) {
          onSuccess(paymentIntent);
        }
      }
    } catch (err) {
      setErrorMessage('An unexpected error occurred.');
      setProcessing(false);
      if (onError) {
        onError(err);
      }
    }
  };

  const cardElementOptions = {
    style: {
      base: {
        fontSize: '16px',
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    },
  };

  return (
    <form onSubmit={handleSubmit} className="payment-form">
      <div className="payment-form-header">
        <h3>Complete Payment</h3>
        <p className="payment-amount">Amount: ${amount}</p>
      </div>

      <div className="card-element-container">
        <label htmlFor="card-element">Card Details</label>
        <CardElement id="card-element" options={cardElementOptions} />
      </div>

      {errorMessage && (
        <div className="payment-error-message">
          {errorMessage}
        </div>
      )}

      <button
        type="submit"
        disabled={!stripe || processing}
        className="payment-submit-button"
      >
        {processing ? 'Processing...' : `Pay $${amount}`}
      </button>

      <div className="payment-security-note">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
        <span>Your payment is secure and encrypted</span>
      </div>
    </form>
  );
}

export default PaymentForm;
